const INTENDED_REDIRECT_KEY = 'intended_redirect'

export const useIntendedRedirect = () => {
    const set = (path: string): void => {
        if (window.sessionStorage.getItem(INTENDED_REDIRECT_KEY)) return
        window.sessionStorage.setItem(INTENDED_REDIRECT_KEY, path)
    }

    const consume = (): string | null => {
        const path = window.sessionStorage.getItem(INTENDED_REDIRECT_KEY)
        window.sessionStorage.removeItem(INTENDED_REDIRECT_KEY)
        return path
    }

    return {
        set,
        consume,
    }
}
